import React from "react";
import Field from "../../Common/Field/Field";
import App from "../../../pages/report/multiSelect";
import Async from "react-select"
import Picky from "react-picky"
import "react-picky/dist/picky.css"
const PatterMasterReport = props => {
    return (
        <div >
            <div class="col-md-12 d-flex justify-content-center text-center mx-auto">
                <div className="col-md-3 px-2" style={{ zIndex: "1001" }}>
                    <label>Customer department</label>
                    <App
                        customerInfo={props.customerWithDepartment}
                        selectedCustomers={props.storeCustomerData}
                    />
                </div>
                <div className="col-md-2 height-adjust" style={{ zIndex: "1001" }}>
                    <label>Pattern Master Name</label>
                    <Async
                        name="assignedTo"
                        value={props.patternMaster}
                        onChange={value =>
                            props.updateState(
                                "patternMaster",
                                value
                            )
                        }
                        placeholder="Find pattern master"
                        options={props.patternMasterList}
                    />
                </div>
                <div className="col-md-2 height-adjust" style={{ zIndex: "1001" }}>
                    <label>Source of request</label>
                    <Field
                        inputType="select"
                        inputName="typeOfRequest"
                        value={props.typeOfRequest}
                        options={props.typeOfRequestOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2 height-adjust" style={{ zIndex: "1001" }}>
                    <label>Sample Type</label>
                    {/* <Field
                        inputType="select"
                        inputName="sampleType"
                        value={props.sampleType}
                        options={props.sampleTypeOptions}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    /> */}
                    <Picky
                        value={props.arrayValue2}
                        options={props.sampleTypeOptions}
                        onChange={props.selectMultipleOption2}
                        open={false}
                        valueKey="value"
                        labelKey="label"
                        multiple={true}
                        includeSelectAll={true}
                        manySelectedPlaceholder={"%s selected"} 
                        allSelectedPlaceholder={"%s selected"}
                        includeFilter={true} 
                        dropdownHeight={300}
                        placeholder="Select a sample type" 
                        disabled={false}
                    />
                </div>
            </div>
            <div className="col-md-12 d-flex justify-content-center text-center mx-auto">
                <div className="col-md-2" style={{ zIndex: "1000" }}>

                    <label>ETA From</label>
                    <Field
                        inputType="date"
                        inputName="fromDate"
                        label="from Date"
                        value={props.fromDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                </div>
                <div className="col-md-2" style={{ zIndex: "1000" }}>
                    <label>ETA To</label>
                    <Field
                        inputType="date"
                        inputName="toDate"
                        label="to Date"
                        value={props.toDate}
                        onChange={props.updateState}
                        disabled={false}
                        className="Select-control"
                    />
                    {/* </div> */}
                </div>
            </div>
        </div>
    );
};

export default PatterMasterReport;


// WEBPACK FOOTER //
// ./src/components/Report/forms/PatternMaster.js